import InvoicesAndBillsSettings from 'components/InvoicesAndBillsSettings/';

export default {
  path: 'invoices-settings',
  component: InvoicesAndBillsSettings
};
